// extracted by mini-css-extract-plugin
module.exports = {"centerElement":"LowerNav_centerElement__11pbH","lowerLinks":"LowerNav_lowerLinks__1K4pe","lowerLinksActive":"LowerNav_lowerLinksActive__34jX_"};